import styled from 'styled-components';

const WiComponent = styled.div`
.pagination .flex.align-middle{
        display: flex;
    }
.pagination .flex.align-middle.fil-select__option{
        text-align:left
}
.pagination button[name="pagination-items"]{
    padding-left: 16px !important;
    padding-right: 16px !important;
    font-size:inherit !important
}
.pagination__input.fil-input{
    text-align:center !important
}

.inlineblock.left-align{
    text-align:left;
    display:inline-block;
    margin-top: 0 !important;
}
@media (max-width: 768px){
    .flex.pagination__nav{
        align-items: end;
    }
}
.fil-datepicker__header.fil-select__btn{
    margin-top:0 !important;
}
.fil-datepicker__arrow{
    margin-top: inherit !important;
    display:inline-flex
}
button.pagination__arrow{
    font-size: 1.125rem !important;
}
button.pagination__arrow:not(:disabled){
    color: #026fad;
  }
button.pagination__arrow:disabled{
    color:  #fff !important;
}
.planviewerCV{
    .content-wrapper {
          padding-top: 0rem !important;
        }
        .grid-container{
            padding-left: 0rem !important;
            padding-right: 0rem !important;
        }
}
`
export default WiComponent;